export const GET_FAQS = 'GET_FAQS';